import Cookies from 'js-cookie';
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import httpInjectorService from 'services/http-injector.service';
import { encryptData } from 'utils/crypto';
import SkeletonWithLoaders from 'components/common/Spinner';

const OrgInviteAccept = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const inviteToken = searchParams.get('token');
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    acceptOrgInvite();
  }, []);

  const acceptOrgInvite = async () => {
    try {
      const reqBody = {
        token: inviteToken,
      };
      const response = await httpInjectorService.acceptOrgInvite(reqBody);
      if (response.status === 'success') {
      
        setisLoading(false);
        Cookies.set('authUser', response.data.tokenid);
        Cookies.set('userRole', encryptData(response.data.role));
        Cookies.set('role_id', encryptData(response.data.role_id));
        Cookies.set('org_id', encryptData(response.data.org_id));
        Cookies.set('user_id', encryptData(response.data.user_id));
        Cookies.set('username', response.data.user_name);
        Cookies.set('email', response.data.email);
        localStorage.setItem('authUser', response.data.tokenid);
        localStorage.setItem(
          'accessModules',
          response.data.accessmodule.Accessmodule,
        );
         localStorage.setItem(
      'accessModules',
      response.data.accessmodule.Accessmodule,
    );
    localStorage.setItem(
  'has-seen-tour',
  String(Boolean(response.data.has_seen_tour))
);
        navigate('/admin/default');
      } else {
        navigate('/login');
      }
    } catch {}
  };

  return (
    <React.Fragment>
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ minHeight: '100vh' }}
        >
          <SkeletonWithLoaders />
        </div>
      )}
    </React.Fragment>
  );
};

export default OrgInviteAccept;
